export * from './lib/UiKitInputPromo';
